import { Edge, Node } from '@xyflow/react'
import { FlowElementsType, IEdgeType } from '../types/wizard-flow'
import { IWizardBlock, WizardBlockType } from '../types/wizard-types'

const mapNodeTypeToWidth: Record<string, number> = {
    [WizardBlockType.TRIGGER]: 230,
    [WizardBlockType.ACTION]: 230,
    [WizardBlockType.LOOP]: 300,
    placeholderNode: 100,
    placeholderCondition: 100,
    [WizardBlockType.CONDITION_GROUP]: 300,
    [WizardBlockType.CONDITION]: 200,
}

const mapNodeTypeToHeight: Record<string, number> = {
    [WizardBlockType.TRIGGER]: 60,
    [WizardBlockType.ACTION]: 60,
    [WizardBlockType.LOOP]: 280,
    placeholderNode: 100,
    placeholderCondition: 100,
    [WizardBlockType.CONDITION_GROUP]: 280,
    [WizardBlockType.CONDITION]: 150,
}

export const NODE_WIDTH = 230
export const NODE_HEIGHT = 60

export const createNode = (item: IWizardBlock): Node<IWizardBlock> => ({
    id: item._id,
    position: item.position || { x: 0, y: 0 },
    data: { label: item.name, ...item },
    width: mapNodeTypeToWidth[item.type],
    height: mapNodeTypeToHeight[item.type],
    type: item.type,
    zIndex: 0,
    style: {},
    connectable: false,
    parentId: item.parentId,
    ...(item.parentId ? { extent: 'parent' } : {}),
})

export const createEdge = (source: string, target: string): Edge => ({
    id: `${source}-${target}`,
    source,
    target,
    type: IEdgeType.CUSTOM_EDGE,
    zIndex: 20,
})

const edgeExists = (edges: Edge[], source: string, target: string): boolean =>
    edges.some(
        edge => (edge.source === source && edge.target === target) || (edge.source === target && edge.target === source)
    )

const addEdges = (item: IWizardBlock, items: IWizardBlock[], flowElements: FlowElementsType): void => {
    if (item.next) {
        const connection = items.find(d => d._id === item.next)
        if (connection) {
            if (!edgeExists(flowElements.edges, item._id, connection._id)) {
                const edge = createEdge(item._id, connection._id)
                flowElements.edges.push(edge)
            }
        }
    }
}

export const wizardBlocksToNodesAndEdges = (items: IWizardBlock[]): FlowElementsType => {
    const flowElements: FlowElementsType = { nodes: [], edges: [] }

    for (const item of items) {
        const node = createNode(item)
        flowElements.nodes.push(node)

        if (item.next) {
            addEdges(item, items, flowElements)
        }
    }

    return flowElements
}

export const wizardBlocksToFlowNodes = (blocks: IWizardBlock[]): Node[] => {
    return blocks.map(block => {
        return createNode(block)
    })
}
